import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import Lottie from "lottie-react";
import data from '../images/success_animation.json'
import logo from '../images/white_logo.png'
import { IoMdCall, IoMdCopy } from 'react-icons/io';
import { TbWorld } from 'react-icons/tb';
import { FaFacebook, FaFirefoxBrowser, FaInstagram, FaLinkedin, FaTwitter, FaWeebly, FaWeibo, FaWhatsapp } from 'react-icons/fa';
import { getBusinessAppointmentDetails, getBusinessDetails, getBusinessDetailsForPatients, getBusinessDocumentsOfPatient, getDetailsForPatients } from '../logic/business/action';
import moment from 'moment';
import { toast } from 'react-toastify';
import {CopyToClipboard} from 'react-copy-to-clipboard';
const SuccessPage = () => {
    const params = useParams();
    const selector = useSelector((state) => state.business);
    console.log(selector?.details?.auto_book,"hellllooo")
    const dispatch = useDispatch();
    useEffect(() => {
        // getBilling(dispatch);

        const id = params.id.split('_');
        if(id.length > 1 && !isNaN(parseInt(id[id.length - 1]))){

          getBusinessDocumentsOfPatient(dispatch,params.appointmentId);
          getBusinessDetails(dispatch, parseInt(id[id.length - 1]));
          getBusinessAppointmentDetails(dispatch, params.appointmentId);
          getBusinessDetailsForPatients(dispatch, parseInt(id[id.length - 1]));
          getDetailsForPatients(dispatch, params.customerId);
        }
      }, []);
  return (<div className='w-screen h-screen bg-blue-700 '>
  <div className='w-full flex justify-center items-center'>
    {
      selector?.details?.url != null && selector?.details?.url !== ''?
      <img src={selector?.details?.url} alt="" width={'100px'} className=''/>:
      <img src={logo} alt="" width={'100px'} height={'100px'} className=''/>
    }
  </div>
<div className='w-full lg:px-10 pb-4 bg-blue-700 text-center'>
          {

        ['pending','rescheduled'].includes(selector?.appointments[0]?.status)?
        <h4 className='text-white font-bold text-xl capitalize'>Congratulations {selector?.detailsCustomer?.full_name} !</h4>
        :   
        <h4 className='text-white font-bold text-xl capitalize'>Sorry {selector?.detailsCustomer?.full_name} !</h4>
      }
  </div>
  {
    params?.id != null && params?.id !== undefined &&  selector?.details != null ?
    <div className='w-full flex flex-col gap-4 items-center rounded-t-3xl bg-white min-h-screen'>
  <div className='w-full p-4 lg:p-10 flex items-center flex-wrap gap-4 '>
  
  <div className='w-full lg:w-[48%] mx-auto flex flex-col items-center p-4 rounded-lg bg-white gap-4'>
      {
        ['pending','rescheduled'].includes(selector?.appointments[0]?.status)?
        <h2 className='font-bold text-lg text-center uppercase'>{`${selector?.appointments[0]?.approved === 1 ? "Your Appointment is booked successfully with":"Your appointment is sent for approval to"}`}<br/>  <span className='text-blue-700'>{selector?.details?.name}</span><br/> {selector?.appointments[0]?.approved === 0 && "We will notify you once it is approved."}</h2>
      :<h2 className='font-bold text-lg text-center uppercase'>Your appointment has been rejected due to some reason. <br/>Please contact on the below mentioned number for details.</h2>
    }
      {/* <h2 className='font-bold text-lg text-center uppercase'>Your Appointment is booked successfully with <br/> <span className='text-blue-700'>{selector?.details?.name}</span></h2> */}
            <div className='w-full relative mt-4 border-green-500 rounded-md border-dashed border-2 flex flex-col items-start p-10 '>
  <div className='absolute -top-[50px] -right-[50px]'>
 {
selector?.appointments[0]?.approved===1 && ['pending','rescheduled'].includes(selector?.appointments[0]?.status) ?
 <Lottie animationData={data} loop={true} width={'50px'} height={'50px'} className='!w-[100px] !h-[100px]'/>:''
 }  
  </div>
                <p><span className='font-semibold'>Full Name</span> - {selector?.detailsCustomer?.full_name}</p>
                <p><span className='font-semibold'>Date</span> - {moment(selector?.appointments[0]?.start_date).format('DD-MM-yyyy')}</p>
                <p><span className='font-semibold'>Staff</span> - {selector?.appointments[0]?.staff_name}</p>
                <p><span className='font-semibold'>Time</span> - {moment(selector?.appointments[0]?.start_time,"HH:mm:ss").format('hh:mm a')}</p>
                <p><span className='font-semibold'>Address</span> - 
                {selector?.details?.address}
                {/* <a href={`http://maps.google.com/maps?z=12&t=m&q=loc:${selector?.details?.lat}+${selector?.details?.long}`} className='highlited' target={'_blank'}><span>{`${selector?.details?.address1}, ${selector?.details?.address2}, ${selector?.details?.area}, ${selector?.details?.city}, ${selector?.details?.state}, ${selector?.details?.country}, ${selector?.details?.zip}`}</span></a> */}
                </p>
                <p><span className='font-semibold'>Phone no.</span> - {selector?.details?.contact}</p>
                <p className='flex items-center gap-4 py-4'>
                  

                  <a href={`https://api.whatsapp.com/send?phone=${selector?.details?.contact}`}>
                    <FaWhatsapp size={'2rem'} color='#0B469D'/>
                  </a>
                  {
                    selector?.details?.facebook !== ''?
                    
                    <a href={selector?.details?.facebook}>
                    <FaFacebook size={'2rem'} color='#0B469D'/>
                  </a>
                    :<></>
                  }
                  {/* {
                    selector?.details?.twitter !== ''?
                    <a href={selector?.details?.twitter}>
                    <FaTwitter size={'2rem'} color='#0B469D'/>
                  </a>
                    :<></>
                  } */}
                  {
                    selector?.details?.instagram !== ''?
                    <a href={selector?.details?.instagram}>
                    <FaInstagram size={'2rem'} color='#0B469D'/>
                  </a>
                    :<></>
                  }
                  {
                    selector?.details?.linkedin !== ''?
                  <a href={selector?.details?.linkedin}>
                    <FaLinkedin size={'2rem'} color='#0B469D'/>
                  </a>
                    :<></>
                  }
                  {
                    selector?.details?.website !== ''?
                  <a href={selector?.details?.website}>
                    <TbWorld size={'2rem'} color='#0B469D'/>
                  </a>
                    :<></>
                  }
                </p>
                {
                  selector?.details?.storage_limit>0?
                  <p className='flex items-center gap-2 highlited w-full'><a className='font-semibold break-words' href={`https://taa.dukaani.in/admin/business/${params.id}/book-appointment/${params.customerId}/upload/${params.appointmentId}`} target={'_blank'}>{(selector.documents && selector.documents.length>0)?'See or Upload Document':'Upload Document'}</a> 
                  <CopyToClipboard text={`https://taa.dukaani.in/admin/business/${params.id}/book-appointment/${params.customerId}/upload/${params.appointmentId}`} onCopy={()=>{}}>
                <IoMdCopy 
                size={30}
                onClick={async()=>{
                  // try {
                    //   // navigator.clipboard
                    //   // await navigator.clipboard.writeText(`http://theappointmentapp.com:3001/admin/business/${params.id}/book-appointment/${params.customerId}/upload/${params.appointmentId}`);
                    //   toast.success('Link copied successfully');
                    // } catch (error) {
                      //   toast.error('Sorry! unable to copy link');
                      
                      // }
                    }}
                    className='cursor-pointer'/> 
                    </CopyToClipboard>
                    </p>:null

                  }
            </div>
      <h2 className='text-blue-700 mt-4 font-bold text-2xl text-center uppercase'>Thank You !</h2>
      <Link to={`/admin/business/${params.id}/book-appointment/${params.customerId}`}><p className='highlited'>Book another appointment</p></Link>
  </div>
  {/* <div className='flex-1'></div> */}
      {/* <div className='flex bg-white flex-col items-center gap-2 w-full fixed bottom-4 left-0'>
  <hr className='w-full border'/>
      <h4 className='text-blue-600 font-bold w-full text-center text-lg'>{selector?.details?.name}</h4>
      <div>
      <div className='flex items-center gap-4' ><MdLocationOn size={24} /> {selector?.details?.address}</div>
      <div className='flex items-center gap-4' ><IoMdCall size={24} /> {selector?.details?.contact}</div>
      <div className='h-4'></div>
      <h4 className='text-blue-600 w-full text-center text-base'>@theappointmentapp</h4>
      </div>
      </div> */}
       <div className='bg-[#0B469D] rounded-t-xl w-full fixed bottom-0 left-0 text-white text-center p-2'>
            @theappointmentapp
        </div>
      {/* <div className='h-40'></div> */}
  </div></div>:''
  }
</div>
  )
}

export default SuccessPage